<template>
  <div></div>
</template>

<script>
export default {
  name: 'reload',
  created () {
    this.$router.push('/apps/vendor-portal/')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reload.vue